/*@ngInject*/
const SectionTemplateEditorNavController = function ($state, $element) {

    $element.addClass('sectionTemplateEditorNav');

    this.isActive = function (buttonName) {
        return $state.includes(buttonName);
    };
};

angular.module('ums.configuration')
    .controller('sectionTemplateEditorNavController', SectionTemplateEditorNavController);
